import React,{useContext} from 'react';
import { ThemeContext } from "../../../context/ThemeContext";
import PerfectScrollbar from "react-perfect-scrollbar";
import glmr100 from "../../../images/glmr100.png";
import ftm100 from "../../../images/ftm100.png";
import boo100 from "../../../images/boo100.png";
import cur100 from "../../../images/cur100.png";
import axl100 from "../../../images/axl100.png";
import bsc100 from "../../../images/bsc100.png";
import xchainimage from "../../../images/xchainimage.png";
import screenshot1 from "../../../images/screenshot1.png";

const ReadMe = () => {

	const { changeBackground, background } = useContext(ThemeContext);
	
	return(
		<>
			<div className="row">
				<div className="col-xl-12">
					<div className="row">
						<div className="col-xl-12 col-xxl-6 col-lg-6">
							<div className="card">
								<div className="card-body">
									<PerfectScrollbar
										style={{ height: "auto" }}
										id="DZ_W_TimeLine"
										className="widget-timeline dz-scroll height370 ps ps--active-y"

									>
										<ul className="timeline">
											<li>
												<div className="timeline-badge primary"></div>
												<p className="m-4 mt-4 text-white" style={{ fontSize:"40px"}}>
																		
												Fantom Q2 2023 Hackathon<br></br>

												<br></br>
												<img src={xchainimage} width="800" alt=""></img><br></br><br></br>

												</p>
												
												<p className="m-4 mt-4 text-dark" style={{ fontSize:"24px"}}>

												To showcase the project, the following chains and protocols were included:<br></br>

												<img src={ftm100} width="50" alt=""></img>
												<img src={boo100} width="50" alt=""></img>
												<img src={cur100} width="50" alt=""></img>
												<img src={axl100} width="50" alt=""></img>
												<img src={glmr100} width="50" alt=""></img>
												<img src={bsc100} width="50" alt=""></img>

										
												</p>

												<br></br>

												<p className="mx-4 mt-2 text-dark" style={{ fontSize:"24px"}}>
												Links<br></br>

												<a href="https://youtu.be/LgA1Qufe7FU"target="_blank" rel="noreferrer">Demo Video </a> <br></br>
												<a href="https://fantom-front-end.vercel.app"target="_blank" rel="noreferrer">Demo Website</a> <br></br>
												
												</p>
												<br></br>
												
												<p className="mx-4 mt-4 text-dark" style={{ fontSize:"24px"}}>
												<h2 className="">General Info</h2>
															
												When it comes to investments, managing risk is of paramount importance.<br></br>

												An approach of invest and forget has a very high risk of ruin for the individual investor and unfortunately this area is often overlooked during the process of forming a trading or investment plan.<br></br>

												The traditional finance industry uses a large variety risk management tools but even the most basic versions of these tools are still missing in DeFi applications.<br></br>

												These include order types such as:<br></br>

												- Limit Market Order<br></br>
												- Stop Market Order<br></br>
												- Bracket Order<br></br>
												- Dollar Cost Averaging (DCA)<br></br>

												<br></br>

												<h3 className="">Limit Market Order</h3>

												A Limit Market order to swap from tokenIn (eg. USDC) for another tokenOut (eg. BOO, WFTM, STG) is an order that only executes the swap when the price of the tokenOut / USDC is lower than the Limit price that the user submitted.<br></br>

												<br></br>

												<h3 className="">Stop Market Order</h3>

												A Stop Market order to swap a tokenIn (eg. BOO, WFTM, STG) for tokenOut (eg. USDC) is an order that executes when the price of tokenIn / USDC is below the Stop price that the user submitted.<br></br>

												<br></br>

												<h3 className="">Bracket</h3>

												A Bracket order is a combination of a special Limit Market and a Stop Market order. In one case the user may have exposure to an existing trade and want to swap a tokenIn (e.g. BOO, WFTM, STG) for tokenOut (eg. USDC) either when the tokenIn / USDC price is above the Limit price submitted (usually used to realise a profit) or when the tokenIn / USDC price falls below the submitted Stop Price (usually used to realise a loss). It is also possible for a user to use a Bracket Order to enter a trade to take advantage of increased volatility.<br></br>

												<br></br>

												<h3 className="">Dollar Cost Averaging (DCA)</h3>

												A Dollar Cost Average swap of tokenIn (eg. USDC) for tokenOut (eg. BOO, WFTM, STG) with number of splits 3 (fully customizable) and block interval 10 (fully customizable), allows a user to split the USDC amount he wants to swap for the tokenOut (eg. BOO, WFTM, STG) into 3 equal size orders and execute the swap at a predetermined fixed number of block intervals, minimizing slippage and achieving a more average price.<br></br>

												<br></br>

												With the above order types, the user can pre-plan when to maximize profits when to minimize losses.<br></br>

												In addition all the above do not require the user to always be in front of the screen. The order types in the project allow the trading opportunities and risk management to be fully automated.<br></br>
												</p>
												<br></br>

												<p className="mx-4 mt-2 text-dark" style={{ fontSize:"24px"}}>
												<h2 className="">Interconnected Contracts</h2>

												Via the Interconnected Contracts technology, a user of any ecosystem e.g. Moonbeam (Polkadot ecosystem), Binance Smart Chain ecoysystem can connect to any Fantom native project.<br></br>

												This opens up the possibilities for app design and UX to mutliple ecosystems, in turn utlizing the powerful dynamics of each chain.<br></br><br></br>

												For example in our case, before this technology, if a BSC or Moonbeam user wanted to have exposure to the main Fantom Currencies (eg. BOO, WFTM, STG) they either had to use a bridge to transfer funds across or invest in a version of these tokens natively brought to their chain but being non-native to their ecosystem, resulting in tokens suffering from limited availability and high DEX slippage.<br></br><br></br>

												Naturally, a BSC or Moonbeam user may want exposure to these currencies without having to change chains or transfer funds to those chains in those ways.<br></br>

												In our project a BSC/Moonbeam user interacts with a BSC or Moonbeam deployed smart contract (AxelarBinaceSatelite / AxelarMoobeamSatelite) to submit and delete orders.<br></br>

												They provide the necessary ERC20 approvals to this smart contract and their instructions are carried from BSC / Moonbeam to Fantom via Axelar resulting in the submission or deletion of their orders.<br></br><br></br>

												It is important to note that at the stage of submitting an order the smart contract reads the user's balance, increasing their allowance to the smart contract for the token they want to swap in but no actual funds are being transferred.<br></br><br></br>
																								
												Note: Incase of deleting an existing order the user's allowance to the smart contract is reduced for the tokenIn reference accordingly. This active management of scaling up and down the users allowance for a tokenIn they were to swap for other tokens ensure responsible order and asset approval management.<br></br><br></br>

												When an order submitted by the BSC / Moonbeam user to the Fantom based Orderbook, it is pushed to the Fantom based execution engine (ExecutionEngineFromBinance / ExecutionEngineFromMoonbeam smart contract) and instructions are sent from the Fantom based execution engine to the AxelarBinaceSatelite / AxelaMoonbeamSatelite smart contract that the user apporoved for the relevant token originally.<br></br><br></br>

												Once the message is received in AxelarBinaceSatelite / AxelarMoobeamSatelite smart contract then it will attempt to transfer the relevant token (axlUSDC) from the user (as originally approved), transfer it via Axelar to the Fantom based Execution Engine so it can then be swapped for the desired tokenOut (eg. BOO, WFTM, STG)<br></br>
																								
												<br></br>
												Note: If the BSC / Moonbeam based users balance is not enough because in the meantime the user has used the funds elsewhere, forgetting to cancel his working order, then the AxelarBinaceSatelite / AxelarMoobeamSatelite smart contract instructs the Fantom based execution smart contract that the order size of the order ready for execution is zero which results in instant order cancelation.<br></br>
												<br></br>
												Once the BSC / Moonbeam user sees his Limit or DCA order being excuted successfully in swapping axlUSDC to BOO, WFTM, STG the respective BOO, WFTM, STG balances are kept in the Fantom based execution engine and this is the balance shown on the screen for a BSC / Moonbeam based user.<br></br>

												In this way the BSC / Moonbeam user transfers axlUSDC only when their orders are ready for execution, benefitting from the Fantom maximum liquidity for the native tokens BOO, WFTM, STG. Their tokens are stored in the Fantom based Execution Engine, ready to be swapped back to axlUSDC and transferred via Axelar to their BSC / Moonbeam based EVM account when they use Stop or Bracket Orders.<br></br>
												<br></br>
												Note: Of course the user could switch chains from BSC / Moonbeam to Fantom and ask to withdraw their tokens BOO, WFTM, STG to his EVM account on Fantom. But we followed the approach that by definition a BSC / Moonbeam user is not obliged to switch chain to get exposure to his tokens but execute all functionality natively from their BSC / Moonbeam EVM account.<br></br>
												<br></br>
												</p>

												<p className="mx-4 mt-2 text-dark" style={{ fontSize:"24px"}}>
												<h2 className="">Chains Used</h2>

												<img src={ftm100} width="50" alt=""></img><br></br>

												Fantom is a high-performance, scalable, customizable, and secure smart-contract platform.<br></br>
												The platform is designed as a next generation of blockchain platform to address several limitations of existing blockchain platforms.<br></br>

												<br></br>

												<img src={boo100} width="50" alt=""></img><br></br>

												SpookySwap utilizes the Fantom network to deliver top speed, security, scalable transactions. It is an all-in-one decentralized exchange for leveraging diversified funds across ecosystems, with the speed of Fantom Opera.<br></br>

												<br></br>

												<img src={cur100} width="50" alt=""></img><br></br>
												
												Curve achieves extremely efficient stablecoin trades by implementing the StableSwap invariant, which has significantly lower slippage for stablecoin trades than many other prominent invariants (e.g., constant-product). Note that in this context stablecoins refers to tokens that are stable representations of one another. This includes, for example, USD-pegged stablecoins (like DAI and USDC), but also ETH and sETH (synthetic ETH) or different versions of wrapped BTC.<br></br>
												
												<br></br>

												<img src={glmr100} width="50" alt=""></img><br></br>

												Moonbeam is a parachain that offers a fully compatible EVM environment with a long list of precompiles that offer added functionality. Moonbeam is offering a vetical hub from Polkadot to other ecosystems such as Fantom Opera, Binance, via General Message passing interconnected contracts<br></br>

												<br></br>

												<img src={axl100} width="50" alt=""></img><br></br>

												Axelar delivers cross-chain communication for Web3 allowing Interchain dApps to be developed. It is possible to call a function in another ecosystem, wait for a callback and even transfer tokens with such instructions.<br></br>

												<br></br>

												<img src={bsc100} width="50" alt=""></img><br></br>

												Binance Smart Chain (BSC) supports the most popular programming languages, flexible tools, and comes with clear and canonical documentation. You can quickly start and deploy your application on a blockchain designed with real use in mind.<br></br>

												<br></br>

												</p>

												<p className="mx-4 mt-2 text-dark" style={{ fontSize:"24px"}}>
												<h2 className="">Walkthrough</h2>
		
												The user chooses their preferred network, Moonbeam, Fantom or BSC.

												The prices of BOO/USDC WFTM/USD and STG/USDC are loaded at the top of the screen and constantly updated from SpookySwap.

												The user sees their account balance in USDC, axlUSDC, BOO, WFTM, and STG.

												The user chooses the type of order they want from Limit Market, Stop Market, Bracket and DCA

												For the users convenience, the DApp automatically prefills the prices and quantities based on current SpookySwap prices and account balances. The user can choose to alter both prices and order sizes.

												User clicks submit.

												Their order appears in the relevant tables Limit, Stop, Bracket or DCA Orders.
												The user can only see their own orders.

												In addition to faciliate the judging we are also exposing the whole orderbook (Limit, Stop, Bracket, DCA) from all accounts along with the Execution engine (for Fantom) that shows visually the smart contract activity in transporting an order from the submission to the execution to user's wallet balance update.

												<br></br>

												<img src={screenshot1} width="1500" alt=""></img><br></br>

												<br></br>

												</p>

												<p className="mx-4 mt-2 text-dark" style={{ fontSize:"24px"}}>
												<h2 className="">Repos</h2>
												Fantom Server<br></br>

												https://github.com/Entity54/Fantom-Server <br></br>

												<br></br>

												Front End Repo<br></br>

												https://github.com/Entity54/Fantom-FrontEnd <br></br>

												<br></br>

												Hard Hat<br></br>

												https://github.com/Entity54/Fantom-Hardhat <br></br>

												<br></br>
												</p>

												<p className="mx-4 mt-2 text-dark" style={{ fontSize:"24px"}}>
												<h2 className="">Installation</h2>
												For the front end, the user can:<br></br><br></br>

												$yarn<br></br>
												$npm start<br></br><br></br>

												(You will have to create your own .env file - further instructions at setup.js)<br></br>
												and can see the front end application at http://localhost:3000/<br></br>
												<br></br>
												</p>

												<p className="mx-4 mt-2 text-dark" style={{ fontSize:"24px"}}>
												<h2 className="">Appendix</h2>
												Key Smart contracts & Explanations - all placed in HardHat Repo<br></br>
												<br></br>
												<h2 className="">Fantom</h2><br></br>

												<h3 className="">OrderManager.sol</h3>
												Responsible to add fresh orders or delete existing working orders.

												Server calls regularly function to update SpookySwap prices and if necessary push orders from working order books to the relevant Execution Engine (ExecutionOrdersEngineFantom.sol) if user is Fantom based or (ExecutionOrdersEngineFromMoonbeam.sol) if user is Moonbeam based or (ExecutionOrdersEngineFromBinance.sol) if user is BSC based.<br></br>
												<br></br>

												<h3 className="">UserRegistry.sol</h3>
												When a user submits a fresh order, this smart contract is called first and in case the user is not already registered it registers their EVM account along with the chain (MOONBEAM or FANTOM or BSC) that the user is based on. This important user registration of the<br></br>
												chain is vital in determining to which execution engine to push a previous working order that now is ready for execution.<br></br>
												<br></br>

												<h3 className="">ExecutionOrdersEngineFantom.sol</h3>
												Performs relevant Swaps via SpookySwap and returns the output token to user’s Fantom based wallet.<br></br>
												<br></br>

												<h3 className="">ExecutionOrdersEngineFromMoonbeam.sol</h3>
												Keeps hold of Limit and DCA orders that require USDC to be deposited to swap for anyX token (BOO, WFTM, STG).

												Uses Axelar and communicates with AxelarMoobeamSatelite to retrieve the equivalent amount of axlUSDC to be transferred from Moonbeam to Fantom (swapped via Curve to USDC) to finance order execution.

												Preserves a running balance of BOO, WFTM and STG for the Moonbeam based user, ready to be swapped back to stable coins and transferred to their wallet when desired.

												Keeps holds of Stop and Bracket orders when triggered but the server performs the relevant SpookySwap transactions swapping the relevant X token (BOO, WFTM, STG) to USDC which is then swapped for axlUSDC (via Curve) and send via Axelar to the users Moonbeam based wallet.<br></br>
												<br></br>
												
												<h3 className="">ExecutionOrdersEngineFromBinance.sol</h3>
												Keeps hold of Limit and DCA orders that require USDC to be deposited to swap for anyX token (BOO, WFTM, STG).

												Uses Axelar and communicates with AxelarBinaceSatelite to retrieve the equivalent amount of axlUSDC to be transferred from BSC to Fantom to finance order execution.

												Preserves a running balance of BOO, WFTM and STG for the BSC based user, ready to be swapped back to stable coins and transferred to their wallet when desired.

												Keeps holds of Stop and Bracket orders when triggered but the server performs the relevant SpookySwap transactions swapping the relevant X token (BOO, WFTM, STG) to USDC which is then swapped for axlUSDC (via Curve) and send via Axelar to the users BSC based wallet.<br></br>
												<br></br>

												<h3 className="">AxelarFantomSatelite.sol</h3>
												Accepts GMP messages from AxelarBinaceSatelite.sol / AxelarMoobeamSatelite.sol for submitting or deleting an order from main OrderManager.sol. It also performs the BSC / Moonbeam user registration at UserRegistry.sol<br></br>
												<br></br>

												<h3 className="">SpookySwap.sol</h3>
												Performs all stable (Curve protocol), and non stable (SpookySwap) swaps and provides X/USDC prices.<br></br>
												<br></br>

												<h2 className="">Moonbeam</h2>
												<br></br>
												<h3 className="">AxelarMoobeamSatelite.sol</h3>
												This is the only smart contract that a Moonbeam based user ever interacts with. They can submit or delete an order. In addition in each case the user increases or decreases axlUSDC allowance so that order execution requires no further interaction and order deletion frees up previous approvals.<br></br>
												<br></br>

												<h2 className="">Binance Smart Chain (BSC)</h2>
												<br></br>
												<h3 className="">AxelarBinanceSatelite.sol</h3>
												This is the only smart contract that a BSC based user ever interacts with. They can submit or delete an order. In addition in each case the user increases or decreases axlUSDC allowance so that order execution requires no further interaction and order deletion frees up previous approvals.<br></br>
												<br></br>

												<h2 className="">Addresses of deployed contracts</h2>

												<br></br>

												<h2 className="">Fantom Opera</h2>

												<h3 className="">
													ordersManager_address = "0x4dF495AcB5911B7042fF60dcdb98CF824C83b345";<br></br>
													usersRegistry_address = "0xbF974CBbd23C6dC01594b26DDCa208C6c9aBA737";<br></br>
													executionOrdersEngine_Fantom_address = "0x4E1a3C116C0c3cb41EFE1164605021845088dF7B";<br></br>
													executionOrdersEngineFromMoonbeam_address = "0x04224199314EC7C87E64135b140023EFac976018";<br></br>
													executionOrdersEngineFromBinance_address = "0xeA4100eDA82F1ef314090721ceFDe92DBC98e734";<br></br>
													axelarFantomSatelite_address = "0x823CCF9927D267a0FC4a625b85fC0136C8506Db3";<br></br>
												</h3>
												<br></br>

												<h2 className="">Moonbeam</h2>

												<h3 className="">
												axelarMoonbeamSatelite_address = "0x4535498af0373d4F60afde3035FF56c99B6E4D82";</h3>
												<br></br>

												<h2 className="">Binance Smart Chain (BSC)</h2>

												<h3 className="">
												axelarBinanceSatelite_address = "0x2b637e9a157d015580CA6cD0223d48cFCcbC3aFb";</h3>
												<br></br>
												</p>
											</li>
										</ul>
									</PerfectScrollbar>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>	
		</>
	)
}
export default ReadMe;